"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var newReturning_1 = __importDefault(require("./newReturning"));
var pagesVisited_1 = __importDefault(require("./pagesVisited"));
var cookie_1 = __importDefault(require("./cookie"));
var subscriber_1 = __importDefault(require("./subscriber"));
var campaignEngagement_1 = __importDefault(require("./campaignEngagement"));
var mobileIdentity_1 = __importDefault(require("./mobileIdentity"));
var croct_1 = __importDefault(require("./croct"));
var TargetCheckerDict = {
    newReturning: newReturning_1.default,
    pagesVisited: pagesVisited_1.default,
    cookie: cookie_1.default,
    subscriber: subscriber_1.default,
    campaignEngagement: campaignEngagement_1.default,
    mobileIdentity: mobileIdentity_1.default,
    croct: croct_1.default
};
exports.default = TargetCheckerDict;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90YXJnZXRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBR0EsZ0VBQXlDO0FBQ3pDLGdFQUF5QztBQUN6QyxvREFBNkI7QUFDN0IsNERBQXFDO0FBQ3JDLDRFQUFxRDtBQUNyRCxvRUFBNkM7QUFFN0Msa0RBQTJCO0FBVTNCLElBQU0saUJBQWlCLEdBQTRCO0lBQy9DLFlBQVksd0JBQUE7SUFDWixZQUFZLHdCQUFBO0lBQ1osTUFBTSxrQkFBQTtJQUNOLFVBQVUsc0JBQUE7SUFDVixrQkFBa0IsOEJBQUE7SUFDbEIsY0FBYywwQkFBQTtJQUNkLEtBQUssaUJBQUE7Q0FDUixDQUFBO0FBRUQsa0JBQWUsaUJBQWlCLENBQUEifQ==